import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<'primary' | 'secondary' | 'tertiary' | 'goGreen' | 'inherit'>
}>

export const Caption1 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="caption1" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
